var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"region"},[_c('p',[_vm._v(_vm._s(_vm.region.description))]),(_vm.isMyRegion(_vm.region.id))?_c('div',{staticClass:"options"},[_c('router-link',{staticClass:"button",attrs:{"to":{
                        name: 'EditRegion',
                        params: { id: _vm.region.id },
                    }}},[_vm._v("Endre")])],1):_vm._e()]),_c('h1',[_vm._v("Fangster")]),_c('CatchList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }